import { Theme } from '@mui/material/styles';

export const getMuiSwitch = (theme: Theme): Record<string, unknown> => ({
  MuiSwitch: {
    styleOverrides: {
      root: {
        height: 24,
        padding: 0,
        width: 48,
      },

      thumb: {
        height: 20,
        width: 20,
      },

      track: {
        backgroundColor: theme.palette.grey[400],
        borderRadius: 26,
      },

      switchBase: {
        backgroundColor: theme.palette.grey[800],
        height: 20,
        margin: 2,
        padding: 0,
        width: 20,

        '&:hover': {
          backgroundColor: theme.palette.grey[800],
        },

        '&.Mui-checked': {
          backgroundColor: theme.palette.common.black,
          transform: 'translateX(24px)',
          '&:hover': {
            backgroundColor: theme.palette.common.black,
          },
        },

        '&.Mui-disabled': {
          backgroundColor: theme.palette.grey[400],

          '&+[class*="MuiSwitch-track"]': {
            backgroundColor: theme.palette.grey[200],
            opacity: 'initial',
          },
        },

        '& svg': {
          color: theme.palette.common.white,
        },
      },
    },
  },
});
